import { FormattedMessage } from 'react-intl';

const ActiveAccountHeader = ({ account }) => (
  <div className="active-account">
    <FormattedMessage id="footer.account" />
    {account?.number} <span> | </span>
    {account?.name} <span> | </span>
  </div>
);

export default ActiveAccountHeader;
